<template>
  <div>
    <div id="main-wrapper" class="show">
      <!-- Header -->
      <!-- Page Title -->
      <!-- Content -->
      <div class="homepage mb-80" v-if="!fulid">
        <div class="container">
          <slot v-if="!setting" />
          <div class="row" v-else>
            <div class="col-xl-3 col-md-4">
              <setting-layout :activeSetting="activeSetting" />
            </div>
            <div class="col-xl-9 col-md-8">
              <slot />
            </div>
          </div>
        </div>
      </div>
      <slot v-else />
    </div>
    <div class="bg_icons" v-if="fulid"></div>
  </div>
</template>

<script>
import SettingLayout from "../dashboards/SettingSideBar";
import TimerPrice from "../plugins/TimerPrice";
export default {
  components: { SettingLayout },
  name: "DashBoardLayout",
  props: {
    active: Number,
    title: Boolean,
    fulid: Boolean,
    setting: Boolean,
    activeSetting: Number,
  },
  mounted() {
    document.querySelector("body").className = "dashboard";
  },
};
</script>
